export const getStyles = () => {
    const styles = {
        card: { p: 2, mb: 2, display: 'flex', flexDirection: 'column' }
    };

    return styles;
};
